// import deformatters
import deformatCurrency from './deformatCurrency';
import deformatPercentage from './deformatPercentage';

/**
 * Calculates principal, rate, and term from loan amount, interest rate, and loan term
 * This calculation (or some of it) is used in all four calculators
 *
 * @param {Object} param0 - object with properties for loan amount, interest rate, and loan term
 * @return {[string, number, number]} - array of calculated principal, rate, and term
 */
function calculatePrincipalRateTerm({
  totalHomeLoanAmount = '0',
  annualInterestRate = '0',
  termOfTheLoan = '0',
  downPayment = '0',
}) {
  const principal =
    deformatCurrency(totalHomeLoanAmount) - deformatCurrency(downPayment);
  const rate = deformatPercentage(annualInterestRate) / 12;
  const term = termOfTheLoan * 12;

  return [principal, rate, term];
}

export default calculatePrincipalRateTerm;



// WEBPACK FOOTER //
// ./scripts/svelte/calculators/util/calculatePrincipalRateTerm.js